import { PdPlacesAutocomplete } from '@/js/App/PdPlacesAutocomplete'
import { Loader } from '@googlemaps/js-api-loader'

const loader = new Loader({
	apiKey: 'AIzaSyB_KDajyt-sWpZH79CCFJuwB-oAXUrWAjI',
	version: 'weekly'
})

loader.importLibrary('places').then(() => {
	const searchForms = document.querySelectorAll<HTMLFormElement>(PdPlacesAutocomplete.selector)

	searchForms.forEach((searchForm) => {
		new PdPlacesAutocomplete(searchForm)
	})
})
